import { createAction, props } from '@ngrx/store';
import { DeviceGroup } from './../../../api/models/device-group.model';
import { Theme } from './../../../api/models/theme.model';
import { ScheduleSummary } from './../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

// export const accountActionTypes = {

// };

// export const getScenesAction = createAction(
//     '[Lighting] Get Scenes for Location via service',
//     props<{ locationId: number }>()
// );

export const loadThemesAction = createAction(
    '[Themes] Load Themes for Location via service',
    props<{ locationId: number }>()
);

export const getThemesAction = createAction(
    '[Themes] Get Themes for Location via service',
    props<{ locationId: number }>()
);

// export const setScenesAction = createAction(
//     '[Lighting] Set Scenes for Location',
//     props<{ scenes: DeviceGroup[] }>()
// );

export const setThemesAction = createAction(
    '[Themes] Set Themes for Location',
    props<{ themes: Theme[] }>()
);

export const setThemeFail = createAction(
    '[Themes] Set Themes Failed for Location',
    props<{ error: any }>()
);
// export const getSceneScheduleSummaryAction = createAction(
//     '[Lighting] Get Scene Schedule Summary for Location via service',
//     props<{ locationId: number }>()
// );

export const getThemeScheduleSummaryAction = createAction(
    '[Themes] Get Theme Schedule Summary for Location via service',
    props<{ locationId: number }>()
);

// export const setSceneScheduleSummaryAction = createAction(
//     '[Lighting] Set Scene Schedule Summary for Location via service',
//     props<{ sceneScheduleSummaryList: ScheduleSummary[] }>()
// );

export const setThemeScheduleSummaryAction = createAction(
    '[Themes] Set Theme Schedule Summary for Location via service',
    props<{ themeScheduleSummaryList: ScheduleSummary[] }>()
);


// export const addSceneSuccess = createAction(
//     '[Lighting] Add Scene Success for location',
//     props<{ accountId: number, locationId: number }>()
// );

export const addThemeSuccess = createAction(
    '[Themes] Add Theme Success for location',
    props<{ theme: Theme }>()
);

export const resetNewlyCreatedTheme = createAction(
    '[Themes] Reset newly created theme object'
);

// export const addDeviceSuccess = createAction(
//     '[Lighting] Add Device Success for location',
//     props<{ accountId: number, locationId: number }>()
// );

// export const updateSceneSuccess = createAction(
//     '[Lighting] Update Scene Success for location',
//     props<{ accountId: number, locationId: number }>()
// );

export const updateTheme = createAction(
    '[Themes] Update Theme for location api call',
    props<{ themeId: number, themeUpdate: any }>()
);

export const updateThemeSuccess = createAction(
    '[Themes] Update Theme Success for location',
    props<{ update: Update<Theme> }>()
);

export const updateThemeFail = createAction(
    '[Themes] Update Theme Fail',
    props<{ error: any }>()
);

export const setDefaultThemeForScene = createAction(
    "[Themes] Set Default Theme for Location",
    props<{ locationId: number }>()
);

export const setDefaultThemeSuccess = createAction(
    "[Themes] Set Default Theme for Location Success",
    props<{ isDefualtThemeSet: boolean, locationId: number }>()
);

export const deleteThemeSuccess = createAction(
    '[Themes] Delete Theme from location',
    props<{ themeId: number }>()
);

export const clear = createAction(
    '[Themes] Clear all Themes'
);

export const themesActionTypes = {
    // getScenesAction,
    // setScenesAction,
    getThemesAction,
    setThemesAction,
    setThemeFail,
    loadThemesAction,
    // getSceneScheduleSummaryAction,
    // setSceneScheduleSummaryAction,
    getThemeScheduleSummaryAction,
    setThemeScheduleSummaryAction,
    clear,
    // addSceneSuccess,
    addThemeSuccess,
    // addDeviceSuccess,
    // updateDeviceSuccess,
    // updateSceneSuccess,
    updateTheme,
    updateThemeSuccess,
    updateThemeFail,
    // getLatestLocationDetails,
    // deleteDeviceSuccess,
    // deleteSceneSuccess,
    deleteThemeSuccess,
    resetNewlyCreatedTheme,
    setDefaultThemeForScene,
    setDefaultThemeSuccess
}
